import { createContext } from "react";

export const SipPhoneContext = createContext();